'use client';

import { createContext, useContext, useRef, useState, type Dispatch, type SetStateAction } from 'react';
import type { WarningDismissals } from './device-warning-clear';

type Pending = { scope: string; key: string } | null;
type Local = { scope: string; dismissed: WarningDismissals } | null;
type WarningClearState = {
  busyRef: { current: { scope: string } | null };
  pending: Pending;
  setPending: Dispatch<SetStateAction<Pending>>;
  local: Local;
  setLocal: Dispatch<SetStateAction<Local>>;
};
const Context = createContext<WarningClearState | null>(null);

/** 같은 현장의 여러 위젯은 요청 잠금과 성공한 표시 세대를 공유합니다. */
export function DeviceWarningClearStateProvider({ children }: { children: React.ReactNode }) {
  const busyRef = useRef<{ scope: string } | null>(null);
  const [pending, setPending] = useState<Pending>(null);
  const [local, setLocal] = useState<Local>(null);
  return <Context.Provider value={{ busyRef, pending, setPending, local, setLocal }}>{children}</Context.Provider>;
}

export function useDeviceWarningClearState() {
  return useContext(Context);
}
